import React, { useRef, useState } from "react";
import { useMutation } from "react-query";
import { useIntl } from "react-intl";
import { useSnackbar } from "notistack";
import { Box, ClickAwayListener, IconButton } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";

import { NameInputMenu } from "../Filter/NameInputMenu";
import { FilterGroup, updateGroup } from "../../services/Alert";
import { ActionTooltip } from "../../components/Tooltips";

export const FilterGroupSave = ({
  group,
  onUpdate,
}: {
  group: FilterGroup;
  onUpdate: (group: FilterGroup) => void;
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  const mutation = useMutation<FilterGroup, Error, FilterGroup>(
    (group: FilterGroup) => updateGroup(group),
    {
      onSuccess: (data) => {
        onUpdate(data);
        setOpen(false);
        enqueueSnackbar(
          intl.formatMessage({ id: "GROUP_SUCCESSFULLY_UPDATED" }),
          {
            variant: "success",
          }
        );
      },
    }
  );

  const handleSubmit = (name: string) => {
    const newGroup = { ...group, name };
    mutation.mutate(newGroup);
  };

  return (
    <>
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <Box>
          <ActionTooltip title={"SAVE_OR_RENAME"}>
            <IconButton
              disabled={group.readonly}
              onClick={() => setOpen((prevOpen) => !prevOpen)}
              ref={anchorRef}
              size={"small"}
              sx={{
                color: "text.accentInverted",
                "&.Mui-disabled.MuiButtonBase-root": {
                  color: "filter.textDisabled",
                },
              }}
            >
              <SaveIcon fontSize="small" />
            </IconButton>
          </ActionTooltip>
          <NameInputMenu
            anchorEl={anchorRef.current}
            error={mutation.error}
            onClose={() => setOpen(false)}
            onSubmit={handleSubmit}
            open={open}
            value={group.name}
          />
        </Box>
      </ClickAwayListener>
    </>
  );
};
